import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { login, logout } from "../../service/auth.service.js";

// Async thunks
export const loginUser = createAsyncThunk(
  "auth/login",
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await Promise.race([
        login(loginData),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error("Request timed out")), 10000)
        ),
      ]);

      if (!response.status) {
        return rejectWithValue(response.message);
      }

      const { token, username, userId, branchId, permissions, message, role } =
        response;

      const parsedPermissions = JSON.parse(permissions);

      return {
        token,
        username,
        userId,
        branchId,
        permissions: parsedPermissions,
        message,
        role,
      };
    } catch (error) {
      return rejectWithValue(error.message || "Login failed");
    }
  }
);

export const logoutUser = createAsyncThunk("auth/logout", async () => {
  await logout();
  return { message: "Logout Successful" };
});

const initialState = {
  authToken: null,
  userId: null,
  branchId: null,
  username: null,
  isAuthenticated: false,
  loading: false,
  error: null,
  permissions: [],
  role: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
    resetInitialize: (state) => {
      state.authToken = null;
      state.userId = null;
      state.branchId = null;
      state.username = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
      state.permissions = [];
      state.role = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.authToken = action.payload.token;
        state.userId = action.payload.userId;
        state.username = action.payload.username;
        state.branchId = action.payload.branchId;
        state.permissions = action.payload.permissions;
        state.isAuthenticated = true;
        state.role = action.payload.role;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        console.log(action);
        state.error = action.payload;
      })
      .addCase(logoutUser.fulfilled, () => {
        return initialState;
      });
  },
});

export const { resetError, resetInitialize } = authSlice.actions;
export default authSlice.reducer;
